import { Injectable } from "@angular/core";
import { confirm } from "@web/app/components/dialogs/confirm";
import {
  AiAgentUiCommand,
  AiAgentUiCommandContext,
  AiAgentUiCommandHandler,
} from "../ai-agent-ui-command.types";

@Injectable({ providedIn: "root" })
export class ConfirmReservationStateHandler implements AiAgentUiCommandHandler {
  supports(type: string): boolean {
    return type === "confirmReservationState";
  }

  async handle(cmd: AiAgentUiCommand, ctx?: AiAgentUiCommandContext): Promise<void> {
    if (!cmd.reservationId || !cmd.action) {
      return;
    }
    const force =
      cmd.forcePayment === true ? " (force payment)" : "";
    const ok = await confirm.yesno(
      `Confirm reservation action "${cmd.action}" on ${cmd.reservationId}${force}?`
    );
    if (!ok || !ctx?.resendMessage) {
      return;
    }
    const forcePart =
      cmd.forcePayment === true ? " forcePayment=true" : "";
    await ctx.resendMessage(
      `Yes, confirm set_reservation_state for reservation ${cmd.reservationId} action ${cmd.action} confirmed=true${forcePart}`
    );
  }
}
